module.exports = __webpack_public_path__ + "img/icon-trash.f010e79b.svg";